import { render, staticRenderFns } from "./PedidoBtnNextEstagio.vue?vue&type=template&id=6272a98a"
import script from "./PedidoBtnNextEstagio.vue?vue&type=script&lang=js"
export * from "./PedidoBtnNextEstagio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports